document.addEventListener("DOMContentLoaded", () => {
  const formInput = document.getElementById("contact-address-input");
  const formSubmitButton = document.getElementById('contact-submit-button');

  formSubmitButton.addEventListener("click", async (event) => {
    checkCoverage(formInput.value.trim(), formSubmitButton);
  });

  formInput.addEventListener("keyup", (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      checkCoverage(formInput.value.trim(), formSubmitButton);
    }
  });
});
